<mmx-charge-card
  [patient]="data.patient"
  [invoice]="data.invoice"
  [chargeAmount]="data.invoice.amountRemaining"
  [compact]="true"
  (newCharge)="dialogRef.close($event)"
></mmx-charge-card>
